import { ServiceProvider } from "Service";
import { Page } from "./Page";
import CancellationToken from "cancellationtoken";

export class VersionPage extends Page {
    private view: kendo.View;

    constructor(serviceProvider: ServiceProvider) {
        super(serviceProvider);
    }

    async render(layout: kendo.Layout, cancellationToken: CancellationToken): Promise<void> {
        await this.initialize("version");
        if (cancellationToken.isCancelled) {
            return;
        }

        const versionTextBlocks = ["assemblies", "applicationDatabase", "dmsDatabase", "appDatabase", "lastConfigChange"];

        for (const textblock of versionTextBlocks) {
            (<any>this.viewModel)[`getTextBlock${textblock}`] = () => {
                this.viewModel.get("TextBlock");
                return this.serviceProvider.TextBlock.get(textblock, "version");
            };
        }

        this.view = new kendo.View(
            `<div class="dms-mapping-header">
                <h1 data-bind="html: getTextBlockpageTitle"></h1>
                <div data-bind="html: getTextBlockpageContent" class="dms-textblock dms-pagecontent"></div>
            </div>

            <div class="row col-12">
                <div class="col-sm-6">
                    <h2 data-bind="html: getTextBlockassemblies"></h4>
                    <div id="assemblies" class="dms-grid"></div>
                </div>
                <div class="col-sm-6">
                    <h2 data-bind="text: getTextBlockapplicationDatabase"></h4>
                    <div id="applicationDatabase" class="dms-grid"></div>
                    <h2 data-bind="html: getTextBlockdmsDatabase"></h4>
                    <div id="dmsDatabase" class="dms-grid"></div>
                    <h2 data-bind="html: getTextBlockappDatabase"></h4>
                    <div id="appDatabase" class="dms-grid"></div>
                    <h2 data-bind="html: getTextBlocklastConfigChange"></h4>
                    <span id="lastConfigChange"></span>
                </div>
            </div>`,
            {
                model: this.viewModel,
                evalTemplate: true,
                wrap: false,
                hide: () => {},
            }
        );

        let version = await this.serviceProvider.Version.get();
        layout.showIn(".dms-content-container", this.view);

        new kendo.ui.Grid($("#assemblies")[0], {
            dataSource: {
                data: version.Assemblies,
                schema: {
                    model: {
                        fields: {
                            Name: { type: "string" },
                            Version: { type: "string" },
                        },
                    },
                },
            },
            scrollable: true,
            height: 682,
            sortable: true,
        });

        new kendo.ui.Grid($("#applicationDatabase")[0], {
            dataSource: {
                data: version.DmsIntVersions,
                schema: {
                    model: {
                        fields: {
                            Date: { type: "date" },
                            Version: { type: "string" },
                        },
                    },
                },
                sort: { field: "Date", dir: "desc" },
            },
            scrollable: true,
            height: 200,
            sortable: true,
            columns: [
                { field: "Date", title: "Execution Date", template: "#= DMS.Util.convertToString(Date) #" },
                { field: "Version", title: "Version" },
            ],
        });

        new kendo.ui.Grid($("#dmsDatabase")[0], {
            dataSource: {
                data: version.DmsVersions,
                schema: {
                    model: {
                        fields: {
                            Date: { type: "date" },
                            Version: { type: "string" },
                        },
                    },
                },
                sort: { field: "Date", dir: "desc" },
            },
            scrollable: true,
            height: 200,
            sortable: true,
            columns: [
                { field: "Date", title: "Execution Date", template: "#= DMS.Util.convertToString(Date) #" },
                { field: "Version", title: "Version" },
            ],
        });

        new kendo.ui.Grid($("#appDatabase")[0], {
            dataSource: {
                data: version.AppVersions,
                schema: {
                    model: {
                        fields: {
                            Date: { type: "date" },
                            Version: { type: "string" },
                        },
                    },
                },
                sort: { field: "Date", dir: "desc" },
            },
            scrollable: true,
            height: 200,
            sortable: true,
            columns: [
                { field: "Date", title: "Execution Date", template: "#= DMS.Util.convertToString(Date) #" },
                { field: "Version", title: "Version" },
            ],
        });

        $("#lastConfigChange").html(version.LastConfigChange?.toString());
    }

    dispose(): void {
        super.dispose();

        if (this.view) {
            this.view.destroy();
        }
    }
}
